module.exports = __webpack_public_path__ + "static/img/zhi.6267eb22.png";